import React from 'react';
import { SvgIcon } from '@mui/material';

function ContactIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 126 125">
      <path
        d="M63.0001 0.060051C28.7301 0.060051 0.850098 27.94 0.850098 62.21C0.850098 75.94 5.3801 88.6 12.9401 98.89C13.3801 99.67 14.0201 100.49 14.7601 101.32C26.1601 115.36 43.5401 124.35 63.0001 124.35C97.2701 124.35 125.15 96.47 125.15 62.2C125.15 27.93 97.2701 0.0500488 63.0001 0.0500488V0.060051ZM63.0001 7.56005C93.1301 7.56005 117.65 32.08 117.65 62.21C117.65 72.36 114.82 81.84 109.97 90C98.5701 76.83 81.7401 68.4801 63.0001 68.4801C44.2601 68.4801 27.4401 76.84 16.0301 90.01C11.1801 81.85 8.3501 72.37 8.3501 62.21C8.3501 32.08 32.8701 7.56005 63.0001 7.56005ZM63.0001 116.86C45.8101 116.86 30.4701 108.87 20.4501 96.42C30.4801 83.98 45.8201 75.98 63.0001 75.98C80.1801 75.98 95.5401 83.96 105.56 96.4C95.5301 108.85 80.1901 116.85 63.0001 116.85V116.86Z"
        fill="currentColor"
      />
      <path
        d="M63.0002 62.82C76.2502 62.82 87.0302 52.04 87.0302 38.79C87.0302 25.54 76.2502 14.76 63.0002 14.76C49.7502 14.76 38.9702 25.54 38.9702 38.79C38.9702 52.04 49.7502 62.82 63.0002 62.82ZM63.0002 22.25C72.1102 22.25 79.5302 29.67 79.5302 38.78C79.5302 47.89 72.1102 55.31 63.0002 55.31C53.8902 55.31 46.4702 47.89 46.4702 38.78C46.4702 29.67 53.8902 22.25 63.0002 22.25Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default ContactIcon;
